export default function WaypointLogo({ className = "h-6 w-6" }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* Pin body — circle */}
      <circle cx="12" cy="10" r="5" stroke="currentColor" strokeWidth="1.75" />
      {/* Inner dot */}
      <circle cx="12" cy="10" r="1.75" fill="currentColor" />
      {/* Pin tail */}
      <path
        d="M12 15 L9.5 20 M12 15 L14.5 20"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Ground line */}
      <line
        x1="8"
        y1="21"
        x2="16"
        y2="21"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
